import { render, staticRenderFns } from "./IconTeaser.vue?vue&type=template&id=290afc9d&scoped=true&"
import script from "./IconTeaser.vue?vue&type=script&lang=js&"
export * from "./IconTeaser.vue?vue&type=script&lang=js&"
import style0 from "./IconTeaser.vue?vue&type=style&index=0&id=290afc9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290afc9d",
  null
  
)

export default component.exports